import { ContainerModule } from 'inversify';
import { DslRuntimeModule, DslRuntimeModuleSymbol } from '@xlearn/common';
import { PlayerModuleSymbol } from '../api';
import { EventStreamListenerSymbol } from '../event-stream';
import { SectionStateService, SectionStateServiceSymbol } from './section-state-service';
import sectionStateStoreModule,
{ SectionStateStoreModule, SectionStateStoreModuleSymbol } from './section-state-store-module';
import { QuerySectionStatesCommand } from './query-section-states-command';
import { SectionStateProjection, SectionStateProjectionSymbol } from './section-state-projection';
import { SectionDslRuntimeModule } from './section-dsl-runtime-module';
import { CourseDslRuntimeModule } from './course-dsl-runtime-module'
import { SectionStateQuery, SectionStateQuerySymbol } from './section-state-query';
import { SectionStatePlayerModule } from './section-state-player-module'

export const sectionStateModule = new ContainerModule((bind) => {
  bind<SectionStateService>(SectionStateServiceSymbol).to(SectionStateService).inSingletonScope();
  bind<SectionStateStoreModule>(SectionStateStoreModuleSymbol).toConstantValue(sectionStateStoreModule);
  bind<SectionStateQuery>(SectionStateQuerySymbol).toConstantValue(sectionStateStoreModule);

  bind<SectionStateProjection>(SectionStateProjectionSymbol).to(SectionStateProjection).inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(SectionStateProjectionSymbol));

  bind(QuerySectionStatesCommand).toSelf();

  bind<DslRuntimeModule>(DslRuntimeModuleSymbol).to(SectionDslRuntimeModule);
  bind<DslRuntimeModule>(DslRuntimeModuleSymbol).to(CourseDslRuntimeModule);

  // player module
  bind(PlayerModuleSymbol).to(SectionStatePlayerModule)
});
